import React from 'react';
import { Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
  banner:{
    width: '100%',
    color: theme.palette.common.white,
    backgroundColor: theme.palette.secondary.dark,
  },
  fixedBanner:{
    width: '100%',
    position: 'fixed',
    color: theme.palette.common.white,
    backgroundColor: theme.palette.secondary.dark,
  }
}));

export default function EnvBanner(props) {

  const classes = useStyles();
  if(process.env.REACT_APP_TYPE != 'production'){
    const bannerClasss = (props.fixed)? classes.fixedBanner : classes.banner;
    return <Typography align="center" className={bannerClasss}>Current environment is {process.env.REACT_APP_TYPE}</Typography>
  }
  return false;
}